import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import API from "./api";
import { showSuccess, showError, showLoading, hideLoading } from "./components/alerts";
const Login = () => {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [passError, setPassError] = useState("");
    const navigate = useNavigate();

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        if (e.target.value !== password) {
            setPassError("Passwords do not match!");
        } else {
            setPassError("");
        }
    };
    const handleLogin = async (e) => {
        e.preventDefault();
        showLoading();
        // alert(email);
        try {
            const response = await API.post("login", {
                username,
                password,
            });
            // console.log(response);
            if (response.status) {
                showSuccess(response.message);
                localStorage.setItem("token", response.access_token);
                navigate("/");
            }
            else {
                showError(response.message);
            }
        } catch (err) {
            hideLoading();
            setError("Invalid credentials or server error");
        }
    };
    const handleRegister = async (e) => {
        e.preventDefault();
        showLoading();
        try{
            const registerResponse = await API.post('register',{
                email,
                username,
                password
            });
        console.log(registerResponse);

            if (registerResponse.status) {
                showSuccess(registerResponse.message);
                localStorage.setItem("token", registerResponse.access_token); // Token Store करें
                navigate("/"); // 👈 Successful Login के बाद Redirect
            }
            else {
                showError(registerResponse.message);
            }
        }
        catch(error){
            hideLoading();
            setError("Invalid credentials or server error");
        }
    }
    useEffect(() => {
        const token = localStorage.getItem('token');
        if(token)
            navigate('/');
        document.title = 'Login Page';
        document.body.className = "";
        document.body.classList.add("login-layout"); // Add class when Login page mounts
        $(document).on("click", ".toolbar a[data-target]", function (e) {
            e.preventDefault();
            var target = $(this).data("target");
            $(".widget-box.visible").removeClass("visible"); // Hide others
            $(target).addClass("visible"); // Show target
        });
        return () => {
            document.body.classList.remove("login-layout"); // Remove class when unmounting
            document.body.className = "no-skin";
            $(document).off("click", ".toolbar a[data-target]");
        };
    }, []);
    return (
        <div className="main-container">
            <div className="main-content">
                <div className="row">
                    <div className="col-sm-10 col-sm-offset-1">
                        <div className="login-container">
                            <div className="center">
                                <h1>
                                    <i className="ace-icon fa fa-leaf green"></i>
                                    <span className="red">Ace</span>
                                    <span className="white" id="id-text2">Application</span>
                                </h1>
                                <h4 className="blue" id="id-company-text">&copy; Company Name</h4>
                            </div>
                            <div className="space-6"></div>
                            <div className="position-relative">
                                <div id="login-box" className="login-box visible widget-box no-border">
                                    <div className="widget-body">
                                        <div className="widget-main">
                                            <h4 className="header blue lighter bigger">
                                                <i className="ace-icon fa fa-coffee green"></i>
                                                Please Enter Your Information
                                            </h4>
                                            {error && <div className="alert alert-danger">{error}</div>}
                                            <div className="space-6"></div>
                                            <form onSubmit={handleLogin}>
                                                <fieldset>
                                                    <label className="block clearfix">
                                                        <span className="block input-icon input-icon-right">
                                                            <input type="text" className="form-control"
                                                                placeholder="Username"
                                                                value={username}
                                                                onChange={(e) => { setUsername(e.target.value); setError('') }} />
                                                            <i className="ace-icon fa fa-user"></i>
                                                        </span>
                                                    </label>
                                                    <label className="block clearfix">
                                                        <span className="block input-icon input-icon-right">
                                                            <input type="password" className="form-control"
                                                                placeholder="Password"
                                                                value={password}
                                                                onChange={(e) => { setError(''); setPassword(e.target.value) }}
                                                                required />
                                                            <i className="ace-icon fa fa-lock"></i>
                                                        </span>
                                                    </label>
                                                    <div className="space"></div>
                                                    <div className="clearfix">
                                                        <label className="inline">
                                                            <input type="checkbox" className="ace" />
                                                            <span className="lbl"> Remember Me</span>
                                                        </label>
                                                        <button type="submit"
                                                            className="width-35 pull-right btn btn-sm btn-primary">
                                                            <i className="ace-icon fa fa-key"></i>
                                                            <span className="bigger-110">Login</span>
                                                        </button>
                                                    </div>
                                                    <div className="space-4"></div>
                                                </fieldset>
                                            </form>
                                        </div>
                                        <div className="toolbar clearfix">
                                            <div>
                                                <a href="#" data-target="#forgot-box" className="forgot-password-link">
                                                    <i className="ace-icon fa fa-arrow-left"></i>
                                                    I forgot my password
                                                </a>
                                            </div>
                                            <div>
                                                <a href="#" data-target="#signup-box" className="user-signup-link">
                                                    I want to register
                                                    <i className="ace-icon fa fa-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="forgot-box" className="forgot-box widget-box no-border">
                                    <div className="widget-body">
                                        <div className="widget-main">
                                            <h4 className="header red lighter bigger">
                                                <i className="ace-icon fa fa-key"></i>
                                                Retrieve Password
                                            </h4>
                                            <div className="space-6"></div>
                                            <p>
                                                Enter your email and to receive instructions
                                            </p>
                                            <form>
                                                <fieldset>
                                                    <label className="block clearfix">
                                                        <span className="block input-icon input-icon-right">
                                                            <input type="email" className="form-control" placeholder="Email" />
                                                            <i className="ace-icon fa fa-envelope"></i>
                                                        </span>
                                                    </label>
                                                    <div className="clearfix">
                                                        <button type="button"
                                                            className="width-35 pull-right btn btn-sm btn-danger">
                                                            <i className="ace-icon fa fa-lightbulb-o"></i>
                                                            <span className="bigger-110">Send Me!</span>
                                                        </button>
                                                    </div>
                                                </fieldset>
                                            </form>
                                        </div>
                                        <div className="toolbar center">
                                            <a href="#" data-target="#login-box" className="back-to-login-link">
                                                Back to login
                                                <i className="ace-icon fa fa-arrow-right"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div id="signup-box" className="signup-box widget-box no-border">
                                    <div className="widget-body">
                                        <div className="widget-main">
                                            <h4 className="header green lighter bigger">
                                                <i className="ace-icon fa fa-users blue"></i>
                                                New User Registration
                                            </h4>
                                            <div className="space-6"></div>
                                            <p> Enter your details to begin: </p>
                                            <form onSubmit={handleRegister}>
                                                <fieldset>
                                                    <label className="block clearfix">
                                                        <span className="block input-icon input-icon-right">
                                                            <input type="email" value={email} onChange={(e) => { setError(''); setEmail(e.target.value) }} className="form-control" placeholder="Email" />
                                                            <i className="ace-icon fa fa-envelope"></i>
                                                        </span>
                                                    </label>
                                                    <label className="block clearfix">
                                                        <span className="block input-icon input-icon-right">
                                                            <input type="text" className="form-control"
                                                                value={username}
                                                                placeholder="Username" onChange={(e) => { setError(''); setUsername(e.target.value) }} />
                                                            <i className="ace-icon fa fa-user"></i>
                                                        </span>
                                                    </label>
                                                    <label className="block clearfix">
                                                        <span className="block input-icon input-icon-right">
                                                            <input type="password" className="form-control"
                                                                value={password}
                                                                placeholder="Password" onChange={(e) => { setError(''); setPassword(e.target.value) }} />
                                                            <i className="ace-icon fa fa-lock"></i>
                                                        </span>
                                                    </label>
                                                    <label className="block clearfix">
                                                        <span className="block input-icon input-icon-right">
                                                            <input type="password" className="form-control"
                                                                value={confirmPassword}
                                                                placeholder="Repeat password" onChange={handleConfirmPasswordChange} />
                                                            <i className="ace-icon fa fa-retweet"></i>
                                                        </span>
                                                    </label>
                                                    {passError && <p className="text-danger">{passError}</p>}
                                                    <label className="block">
                                                        <input type="checkbox" className="ace" />
                                                        <span className="lbl">
                                                            I accept the
                                                            <a href="#">User Agreement</a>
                                                        </span>
                                                    </label>
                                                    <div className="space-24"></div>
                                                    <div className="clearfix">
                                                        <button type="reset" className="width-30 pull-left btn btn-sm">
                                                            <i className="ace-icon fa fa-refresh"></i>
                                                            <span className="bigger-110">Reset</span>
                                                        </button>
                                                        <button type="submit"
                                                            className="width-65 pull-right btn btn-sm btn-success">
                                                            <span className="bigger-110">Register</span>
                                                            <i className="ace-icon fa fa-arrow-right icon-on-right"></i>
                                                        </button>
                                                    </div>
                                                </fieldset>
                                            </form>
                                        </div>
                                        <div className="toolbar center">
                                            <a href="#" data-target="#login-box" className="back-to-login-link">
                                                <i className="ace-icon fa fa-arrow-left"></i>
                                                Back to login
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Login;
